import styled, { css } from 'styled-components/macro';

import Box from 'components/elements/Box';
import Layout from 'components/styled/Layout/Layout';
import { Toolbar } from 'components/utility/GenericComponent/GenericComponent';
import { WhiteBlock } from 'components/utility/GenericComponent/GenericComponent';
import { TableControls } from 'components/data-containers/BrowseEntities/BrowseControls/BrowseControls';
import { Buttons } from 'components/data-visualization/Table/Sort';
import { HeaderContainer } from 'components/Header/EntityHeader/EntityHeader.style';

export const TopicFiltersWrap = styled('div')`
  & > ${Box} {
    margin: ${({ theme }): string =>
      `${theme.spacing.small} ${theme.spacing.small} 0`};
    @media screen and (min-width: 40em) {
      width: ${({ theme }): string =>
        `calc(100% - ${theme.spacing.small} * 2)`};
    }
    @media screen and (min-width: 60em) {
      margin: ${({ theme }): string => theme.spacing.medium} auto 0;
      width: 78.2%;
    }
    span {
      @media screen and (max-width: 40em) {
        font-size: 1rem;
        font-weight: 600;
      }
    }
  }
`;

export const CustomListRouteWrap = styled('div')<any>`
  ${HeaderContainer} {
    margin-top: ${({ theme }): string => theme.topbarHeight};
  }
  ${WhiteBlock} {
    margin: ${({ theme }): string => theme.spacing.small};
    width: auto;
    @media screen and (min-width: 60em) {
      margin: ${({ theme }): string => theme.spacing.medium} auto;
      width: 78.2%;
    }
  }
  ${Layout.MaxWidth} {
    width: ${({ isReadMode }): string => (isReadMode ? '100%' : '90%')};
    max-width: ${({ isReadMode }): string =>
      isReadMode ? '100%' : 'calc(100% - (1em * 2))'};
  }
  ${Toolbar} {
    padding: ${({ theme }): string =>
      `${theme.spacing.small} ${theme.spacing.small} 0`};
    transform: none;
    @media screen and (min-width: 40em) {
      padding: ${({ theme }): string =>
        `${theme.spacing.xlarge} ${theme.spacing.xlarge} ${theme.spacing.small}`};
    }
  }
  ${({ isReadMode }): any =>
    isReadMode &&
    css`
      ${TableControls} {
        margin-top: -0.5em;
      }
      ${Buttons} {
        margin: ${({ theme }): string => theme.spacing.xsmall} 0;
      }
    `};
`;
